<template>
    <v-container fluid class="pa-4" style="height: inherit; background-color: white;">

        <h3 class="mb-3">{{ $t('servicesystem.common_objects.export.transactions') }}</h3>

        <template v-if="loading">
            <v-progress-linear :indeterminate="loading" color="primary" style="width: 410px;">
            </v-progress-linear>
        </template>

        <template v-else-if="!loading && anyExportableFiles">
            <table style="border: 1px solid var(--v-disabled-base); border-collapse: collapse;">
                <thead style="text-align: left; background-color: #f1f1f1;">
                    <tr>
                        <th class="px-3 py-2">{{ $t('servicesystem.common_objects.export.col1') }}</th>
                        <th class="px-3 py-2">{{ $t('servicesystem.common_objects.export.col2') }}</th>
                        <th class="px-3 py-2">{{ $t('servicesystem.common_objects.commonterms.date') }}</th>
                    </tr>
                </thead>
                <tbody style="text-align: left; background-color: white;">
                    <tr>
                        <td class="px-3">
                            <!-- templated export options -->
                            <v-col class="d-flex flex-column justify-start pa-0">
                                <v-btn v-for="fileOption in exportData.ExportFileOptions" :key="fileOption.name"
                                    color="primary" text style="text-transform: none;" class="d-flex justify-start px-0"
                                    @click="exportFile(fileOption)">
                                    <v-icon size="20" class="mr-1"> {{ transformIcon(fileOption.transform) }} </v-icon>
                                    {{ fileOption.name }}
                                </v-btn>
                            </v-col>
                        </td>
                        <td class="px-3" style="vertical-align: top;">
                            <!-- native file export -->
                            <v-btn color="primary" text style="text-transform: none;" class="d-flex justify-start px-0"
                                @click="exportFile({ fileName: '/export/Transactions.xml', template: '', transform: '' })">
                                <v-icon size="20" class="mr-1">mdi-file-xml-box</v-icon>
                                Transactions
                            </v-btn>
                        </td>
                        <td class="px-3" style="vertical-align: top;">
                            <p class="pt-2">
                                {{ exportData.ExportDate }}
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <v-btn class="my-2" @click="deleteFiles()">
                {{ $t('servicesystem.common_objects.export.clear_transactions') }}
            </v-btn>
        </template>
        <template v-else>
            {{ $t('servicesystem.common_objects.export.no_files') }}
        </template>
    </v-container>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';

export default {
    name: 'LegacyExport',
    props: {},
    components: {},
    mixins: [ClientAPIMixin],

    data() {
        return {
            exportData: null,
            loading: false,
        };
    },

    mounted() {
        if (this.userAllowedImportExport) {
            this.getData();
        }
    },

    methods: {
        transformIcon(transform) {
            if (transform == 'excel') {
                return 'mdi-microsoft-excel';
            } else if (transform == 'text') {
                return 'mdi-text-box';
            } else {
                return 'mdi-file-xml-box';
            }
        },

        getData() {
            this.loading = true;
            this.getLegacyExportView()
                .then((response) => {
                    this.exportData = response;
                    this.loading = false;
                });
        },

        async exportFile({ fileName, template, transform }) {
            var response = await this.getLegacyExportFile({ fileName, template, transform });
            var blob = new Blob([response.data], { type: response.headers['content-type'] });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            var contentDisposition = response.headers['content-disposition'];
            if (contentDisposition.includes('filename="')) {
                link.download = contentDisposition.split('filename="')[1].split('";')[0];
            }
            else {
                link.download = contentDisposition.split('filename=')[1].split(';')[0];
            }
            link.click();
        },

        deleteFiles() {
            this.deleteLegacyExportFiles(this.exportData.ExportDate)
                .then(() => {
                    this.getData();
                });
        }
    },

    computed: {
        anyExportableFiles() {
            return this.exportData && this.exportData.ExportDataFiles[0];
        }
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>